module.exports = __webpack_public_path__ + "img/album21_04.eed393f7.jpg";